export default "__VITE_ASSET__10ce8a1a__"